import React from 'react';
import {AtButton, AtIcon} from 'taro-ui';
import styled, {css} from "styled-components";
const ButtonWrapper = styled.div<{
  color: string;
  backgroundColor: string;
  buttonVariant: string;
  fontSize: number;
  fontStyle: string;
  borderRadius: string;
  boxShadow: string;
  placement: string;
  disabled:boolean;
}>`
  width: 100%;
  height: 100%;
  .at-button{
    padding: 0 10px;
    background: ${({backgroundColor, buttonVariant})=> buttonVariant=='primary' ? backgroundColor : 'transparent'};
    color: ${({color})=> color};
    font-size: ${({fontSize})=> fontSize}!important;
    border-radius: ${({borderRadius})=> borderRadius};
    box-shadow: ${({boxShadow})=> boxShadow};

    ${({disabled}) =>
      !disabled &&
        css`
          &:hover{
            opacity: .9;
          }
        `
    }

    border-color: ${({backgroundColor, buttonVariant})=> buttonVariant == "text"?'transparent':backgroundColor};
    .at-button__text{
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: ${({placement})=> placement};
      font-style: ${({fontStyle})=> fontStyle&&fontStyle.indexOf('ITALIC')>=0&&'italic'};
      font-weight: ${({fontStyle})=> fontStyle&&fontStyle.indexOf('BOLD')>=0&&'bold'};
    }
  }
`;
const BtnContent = (props:any)=>{
  const {iconAlign, label, iconName, fontSize, color} = props;
  return (
    <>
      {
        iconAlign == 'right' && label
      }
      {
        iconName && <AtIcon value={iconName} color={color} />
      }
      {
        iconAlign == 'left' && label
      }
    </>
  )
}
const TButtonWidget = (props:any) => {
  const {
    label,
    onClick,
    buttonVariant,
    isCircle,
    isDisabled,
    btnLoading,
    backgroundColor,
    fontSize,
    fontStyle,
    color,
    borderRadius,
    boxShadow,
    placement,
    iconName,
    iconAlign
  } = props;

  return (
    <ButtonWrapper
      backgroundColor={backgroundColor}
      fontSize={fontSize}
      fontStyle={fontStyle}
      color={color}
      buttonVariant={buttonVariant}
      borderRadius={borderRadius}
      boxShadow={boxShadow}
      placement={placement}
      disabled={isDisabled}
    >
      <AtButton
        loading={btnLoading}
        type={buttonVariant}
        onClick={onClick}
        circle={isCircle}
        disabled={isDisabled}
      >
        <BtnContent label={label} fontSize={fontSize} iconName={iconName} iconAlign={iconAlign} />
      </AtButton>
    </ButtonWrapper>
  );
};

export default TButtonWidget;
